import React from 'react';
import Home from '../pages/Home';
import WebHosting from '../pages/WebHosting';
import WebHostingAiPreview from '../pages/WebHostingAiPreview';
import WebHostingEditor from '../pages/WebHostingEditor';
import MonitorPage from '../pages/Monitor';
import About from '../pages/About';
import AIInfo from '../pages/AIInfo';
import Faq from '../pages/Faq';
import Demo from '../pages/Demo';
import Directories from '../pages/Directories';
import EndpointList from '../pages/EndpointList';
import International from '../pages/International';
import ImageCategories from '../pages/ImageCategories';
import Galleries from '../pages/Galleries';
import ImageProcessing from '../pages/ImageProcessing';
import ImageWatermark from '../pages/ImageWatermark';
import FormatConvert from '../pages/FormatConvert';
import ImageCompress from '../pages/ImageCompress';
import VideoToGif from '../pages/VideoToGif';
import VideoCompressor from '../pages/VideoCompressor';
import Mp3Compressor from '../pages/Mp3Compressor';
import VideoToAudio from '../pages/VideoToAudio';
import AIGenerate from '../pages/AIGenerate';
import ImageSearch from '../pages/ImageSearch';
import Trash from '../pages/Trash';
import Invite from '../pages/Invite';
import InviteWelcome from '../pages/InviteWelcome';
import EncryptedLinks from '../pages/EncryptedLinks';
import SaleLinks from '../pages/SaleLinks';
import SaleCodes from '../pages/SaleLinks/SaleCodes';
import SaleBuyer from '../pages/SaleLinks/SaleBuyer';
import SaleAccount from '../pages/SaleLinks/SaleAccount';
import DirectoryShare from '../pages/DirectoryShare';
import NotFound from '../pages/NotFound';
import type { ImgCloudPageKey } from './pageKeys';
import { IMG_CLOUD_ROUTE_METADATA } from './routeMetadata';
import type { ImgCloudRouteMetadata } from './routeMetadata';

export interface ImgCloudRouteDefinition extends ImgCloudRouteMetadata {
  element: React.ReactElement;
}

const PAGE_ELEMENTS: Readonly<Record<ImgCloudPageKey, React.ReactElement>> = {
  home: <Home />,
  'web-hosting': <WebHosting />,
  'web-hosting-ai-preview': <WebHostingAiPreview />,
  'web-hosting-editor': <WebHostingEditor />,
  galleries: <Galleries />,
  directories: <Directories />,
  'endpoint-list': <EndpointList />,
  international: <International />,
  'image-categories': <ImageCategories />,
  monitor: <MonitorPage />,
  about: <About />,
  'ai-info': <AIInfo />,
  faq: <Faq />,
  demo: <Demo />,
  'image-processing': <ImageProcessing />,
  'image-watermark': <ImageWatermark />,
  'format-convert': <FormatConvert />,
  'image-compress': <ImageCompress />,
  'video-to-gif': <VideoToGif />,
  'video-compressor': <VideoCompressor />,
  'mp3-compressor': <Mp3Compressor />,
  'video-to-audio': <VideoToAudio />,
  'ai-generate': <AIGenerate />,
  'image-search': <ImageSearch />,
  trash: <Trash />,
  invite: <Invite />,
  'invite-welcome': <InviteWelcome />,
  'encrypted-links': <EncryptedLinks />,
  'sale-links': <SaleLinks />,
  'sale-codes': <SaleCodes />,
  'sale-buyer': <SaleBuyer />,
  'sale-account': <SaleAccount />,
  'directory-share': <DirectoryShare />,
};

export const IMG_CLOUD_ROUTE_DEFINITIONS: readonly ImgCloudRouteDefinition[] =
  IMG_CLOUD_ROUTE_METADATA.map((metadata) => ({
    ...metadata,
    element: metadata.pageKey ? PAGE_ELEMENTS[metadata.pageKey] : <NotFound />,
  }));
